import type { ToolManager } from '~/engine/tool/ToolManager';
import { PanZoom } from '~/engine/view/PanZoom';
import { NO_OP_VIEW_INVALIDATOR } from '~/engine/view/ViewInvalidator';

/**
 * Arms the neutral pan tool on `toolManager`, bound to no environment, so
 * the grid never sits without an armed tool. The bound PanZoom is a config
 * requirement only: pan, zoom and windowing resolve their environment per
 * event from the view pressed.
 */
export function armPan(toolManager: ToolManager): void {
    toolManager.setActiveTool({
        tool: 'pan',
        panZoom: new PanZoom(NO_OP_VIEW_INVALIDATOR),
        environment: undefined,
        views: undefined,
    });
}
